import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { IChatController, ChatAdapter, ParticipantResponse, ChatParticipantType } from 'ng-chat';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ChatService } from 'src/app/utils/chat/chat.service';
import { NzkChatAdapter } from 'src/app/utils/chat/nzk.chat.adapter';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { WebSocketService } from 'src/app/utils/chat/websocket.service';
import { SOCKET_CHAT_NOTIFICATION_ENDPOINT_URL } from 'src/app/utils/chat/chat-constants';
import * as CommonConstants from '../../utils/common.constants';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import swal from 'sweetalert2';
import { MasterService } from '../../masters/master.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AddMedicalCarePlanComponent } from 'src/app/medical-file/medical-care-plan/add-medical-care-plan/add-medical-care-plan.component';
import { UserService } from 'src/app/user/user.services';
import { SharedService } from 'src/app/utils/shared.service';

@Component({
  selector: 'app-case-review',
  templateUrl: './case-review.component.html',
  styleUrls: ['./case-review.component.scss']
})
export class CaseReviewComponent implements OnInit, OnDestroy {

  @Input()
  fileId;

  @Input()
  userId;
  // QuestionModel;
  question;
  questionForm: FormGroup;
  userList = [];
  affectationForm: FormGroup;
  questionRowData;
  stompChatClient;
  chatSubscription;

  subject: string;
  content: string;
  selectName: string;
  recievedFileDate: string;
  pathology: string;
  affectationType: string;
  associatedPathology1: string;
  visitDate: Date;
  associatedPathology2: string;
  speciality: string;
  ageCategory: string;
  patientGender: string;
  duration: string;

  title = "Case Review Chat";
  hospitalList;
  practionerList;
  selectedPractitioner;
  selectedHospital;
  selectedRespondentsList;
  crHospList = [];
  crPractList = [];
  partnerList = [];
  affectations=[];
  commentDesc;
  comments;
  modalRef: BsModalRef;
  dropdownSettings: IDropdownSettings;
  PARAM_KEY = [CommonConstants.GENDER];
  SERVICE_KEYS = [CommonConstants.MED_QUESTIONS, CommonConstants.MED_CASE_REVIEW_HOSP, CommonConstants.MED_CASE_REVIEW_PRACT,CommonConstants.MED_CASE_AFFECTATIONS];
  masterValues=[];
  specialities=[];
  gender=[];
  constructor(private chatService: ChatService, private webSocketService: WebSocketService, private sharedService: SharedService,private medicalFileService: MedicalFileService, private modalService: NgbModal, private bsMdalService: BsModalService, private formBuilder: FormBuilder, private masterService: MasterService, private toastrService: ToastrService,private userService:UserService) {
    this.getFromGroup();
    this.loadUsers();
    this.getAffectationFormGroup();
    this.loadMaster();
  }
  

  @ViewChild('ngChatInstance', { static: false }) chatInstance: IChatController;

  public adapter: ChatAdapter;
  newChatSubscription: Subscription;
  closeSubscription: Subscription;

  ngOnInit() {
    this.cleanup();
    this.fileId ? this.connectWS() : '';
    this.loadQuestions();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'partnerid',
      textField: 'partnername',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.loadPartners();
  }
  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.gender = this.masterValues.filter(master => master.paramKey === CommonConstants.GENDER);
      }
    });
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
  }
  /**
 * Declare form group
 *  
 */
  private getFromGroup() {
    this.questionForm = this.formBuilder.group({
      'subject': new FormControl(),
      'contentData': new FormControl(),
      'respondents': [null],
      'medfiId':[null]
    })

  }
  loadUsers(){
    let jsonData={};
    this.userService.searchUser(jsonData).subscribe(response => {
      this.userList = response['result'];
    })
  }
  get f() { return this.affectationForm.controls; }

  private getAffectationFormGroup() {
    this.affectationForm = this.formBuilder.group({
      'medafQtyOfReceivedFileAndDate': new FormControl(),
      'medafMainPathology': new FormControl(),
      'affecId': new FormControl(),
      'medafAssociatedPathology1': new FormControl(),
      'medafPatientLastMedicalVisitDate': new FormControl(),
      'medafAssociatedPathology2': new FormControl(),
      'spltyId': new FormControl(),
      'medafAgeCategory': new FormControl(),
      'gender': new FormControl(),
      'medafDuration': new FormControl() ,
      'medafId': [null],
      'medfiId':[null],
      'staRecCode':[null],
      'secUsrIdCreated':[null]
    })
  }
  

  connectWS() {
    this.adapter = new NzkChatAdapter(this.fileId, this.userId, this.chatService);
    this.openSocket();

    this.newChatSubscription = this.chatService.newChat.subscribe(newChat => {
      if (newChat) {
        this.chatInstance.triggerOpenChatWindow(newChat);
      }
    });

    this.closeSubscription = this.chatService.closeChat.subscribe(event => {
      if (event) {
        this.chatInstance.triggerCloseChatWindow(event.closeId);
        this.chatInstance.triggerOpenChatWindow(event.openId);
      }
    })
  }

  openSocket() {

    if (this.chatSubscription) {
      this.chatSubscription.unsubsribe();
    }

    this.stompChatClient = this.webSocketService.connect();

    //Subscribe to chat topic of the logged in patient
    this.stompChatClient.connect({}, frame => {
      this.stompChatClient.subscribe(SOCKET_CHAT_NOTIFICATION_ENDPOINT_URL + this.userId, msg => {
        let chat = JSON.parse(msg.body);
        // Swal.fire('New chat recieved!', '', 'info');

        let participant = {
          participantType: ChatParticipantType.User,
          id: chat['prevMessageId'] + chat['createdBy'],
          status: 4,
          avatar: null,
          displayName: chat['createdName']
        };

        let message = {
          dateSent: new Date(chat['createdDate']),
          fromId: chat['createdBy'],
          message: chat['messageBody'],
          toId: this.fileId,
          type: 1
        }

        let participantResponse: ParticipantResponse = new ParticipantResponse();
        participantResponse.participant = participant;
        participantResponse.metadata = {
          totalUnreadMessages: 1
        }
        this.chatService.messageReceived(chat['prevMessageId'] + chat['createdBy'], participantResponse);
        this.adapter.onMessageReceived(participant, message);
      })
    });
  }

  onParticipantChatOpened(event) {
    this.chatService.selectedChatId.next(event.id);
    this.chatService.markAsRead(event.id, this.fileId);
  }

  cleanup() {
    this.adapter = null;
    if (this.newChatSubscription) this.newChatSubscription.unsubscribe();
    if (this.closeSubscription) this.closeSubscription.unsubscribe();
  }

  loadQuestions() {
    this.medicalFileService.getDetailsByKeys(this.fileId, this.SERVICE_KEYS).subscribe(response => {
      if (response && response['code'] === 'S0000' && response['result']) {
        this.questionRowData = response['result'][CommonConstants.MED_QUESTIONS];
        if(this.questionRowData && this.questionRowData.length > 0){
          this.onQuestionSelect(this.questionRowData[0]);
        }
        let medPractioner = response['result'][CommonConstants.MED_CASE_REVIEW_PRACT];
        let medHopsitals = response['result'][CommonConstants.MED_CASE_REVIEW_HOSP];
        this.affectations = response['result'][CommonConstants.MED_CASE_AFFECTATIONS];
        for (let item of medPractioner) {
          this.crPractList.push(this.practionerList.filter(pract => pract.partnerid === item.prtieId)[0]);
        }
        for (let item of medHopsitals) {
          this.crHospList.push(this.hospitalList.filter(hosp => hosp.partnerid === item.hospiId)[0]);
        }
      } else {
        swal.fire("Error", response['message'], 'error');
      }
    },
      error => {
        swal.fire("Error", "Error Occured While Fetching Medical File Details", 'error');
      })
  }
  loadPartners() {
    this.medicalFileService.loadPartnersForCaseReview().subscribe(response => {
      if (response && response['code'] === 'S0000' && response['result']) {
        this.partnerList = response['result'];
        this.hospitalList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_HOSPITAL_TYPE);
        this.practionerList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
        this.loadQuestions();
      } else {
        swal.fire("Error", response['message'], 'error');
      }
    },
      error => {
        swal.fire("Error", "Error Occured While Fetching Partners", 'error');
      })
  }
  saveCaseReviewPractioners() {
    let practioners = [];
    for (let item of this.selectedPractitioner) {
      let jsonData = {
        "medfiId": this.fileId,
        "prtieId": item.partnerid,
        "staRecCode": "A",
      }
      practioners.push(jsonData);
    }
    this.medicalFileService.saveCaseReviewAddPract(practioners).subscribe(res => {
      if (res['result'] && res['code'] === "0") {
        this.toastrService.success(res['message'], 'Success');
        for (let item of res['result']) {
          this.crPractList.push(this.practionerList.filter(pract => pract.partnerid === item.prtieId)[0]);
        }
        this.selectedPractitioner = [];
      } else {
        this.toastrService.error(res['message'], 'Error');
      }
    })
  }
  saveCaseReviewHospitals() {
    let hospitals = [];
    for (let item of this.selectedHospital) {
      let jsonData = {
        "medfiId": this.fileId,
        "hospiId": item.partnerid,
        "staRecCode": "A",
      }
      hospitals.push(jsonData);
    }
    this.medicalFileService.saveCaseReviewAddHosp(hospitals).subscribe(res => {
      if (res['result'] && res['code'] === "0") {
        this.toastrService.success(res['message'], 'Success');
        for (let item of res['result']) {
          this.crHospList.push(this.hospitalList.filter(hosp => hosp.partnerid === item.hospiId)[0]);
        }
        this.selectedHospital = [];
      } else {
        this.toastrService.error(res['message'], 'Error');
      }
    })
  }
  carePlanAddModal() {
    this.modalRef = this.bsMdalService.show(AddMedicalCarePlanComponent, { class: 'modal-xl' });
    this.modalRef.content.modalreference = this.modalRef;
    this.modalRef.content.medFileId = this.fileId;
  }
  onRowSelect() {
    //this.comments = this.questionRowData
  }

  addQuestionModal(addQuestion) {
    this.modalService.open(addQuestion, { container: '.page-content' });
  }

  saveQuestion() {
    let respondents=[];
    for(let item of this.selectedRespondentsList){
        let respondent={};
        respondent["userId"]=item.secUsrId;
        respondent["userName"]=item.partnername;
        respondents.push(respondent);
    }
    this.questionForm.patchValue({respondents : respondents,medfiId:this.fileId});
     this.medicalFileService.saveQuestions(this.questionForm.value).subscribe(res => {
      if (res['result'] && res['code'] === "0") {
        this.questionRowData.push(res['result']);
        this.toastrService.success(res['message'], 'Success');
      } else {
        this.toastrService.error(res['message'], 'Error');
      }
    }) 
  }
  addAffectationModal(addAffectation){
    this.modalService.open(addAffectation, { size: 'lg', container: '.page-content' });
  }
  saveComments() {
    let comment={
      "questionidId":this.question.questionidId,
      "commentDesc":this.commentDesc,
      "userId":+localStorage.getItem(CommonConstants.USERID)
    }
    this.medicalFileService.saveComments(comment).subscribe(res => {
     if (res['result'] && res['code'] === "0") {
       this.toastrService.success(res['message'], 'Success');
       this.commentDesc='';
       this.comments.push(res['result']);
     } else {
       this.toastrService.error(res['message'], 'Error');
     }
   }) 
 }
 saveAffectation(){
   this.affectationForm.patchValue({medfiId:this.fileId,secUsrIdCreated:+localStorage.getItem(CommonConstants.USERID)});
   this.affectationForm.patchValue({medafPatientLastMedicalVisitDate:this.f.medafPatientLastMedicalVisitDate.value ? this.sharedService.getDateFormat(this.f.medafPatientLastMedicalVisitDate.value) : null});
   this.medicalFileService.saveAffectations(this.affectationForm.value).subscribe(res => {
    if (res['result'] && res['code'] === "0") {
      this.toastrService.success(res['message'], 'Success');
      this.affectations.push(res['result']);
      this.modalService.dismissAll();
    } else {
      this.toastrService.error(res['message'], 'Error');
    }
  },
  error => {
    swal.fire("Error", "Error Occured While Saving Affectation", 'error');
  })
 }
 onQuestionSelect(question){
   this.comments=[];
   if(question.data){
    this.question=question.data;
   }else{
    this.question=question;
   }
  this.medicalFileService.getComments(this.question.questionidId).subscribe(response => {
    if (response && response['code'] === 'S0000' && response['result']) {
      this.comments=response['result'];
    } 
  },
    error => {
      swal.fire("Error", "Error Occured While Fetching Comments Details", 'error');
    })
 }
 get affectationControls() { return this.affectationForm.controls; }
 onAffectationSelect(event,addAffectation){
  let affectation = event.data;
  this.affectationForm.patchValue({});
  Object.keys(affectation).forEach(name => {
    if (affectation[name] && !CommonConstants.AUDITABLE_ENTITY.includes(name)) {
        this.affectationControls[name].patchValue(affectation[name]);
    }
  });
  this.modalService.open(addAffectation, { size: 'lg', container: '.page-content' });
}
  ngOnDestroy() {
    this.cleanup()
  }
  sendToCurrentPatient(){
    swal.fire({
      title: 'Are you sure?',
      text: 'Medical file will go to current patient status, Please Confirm!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, send it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        let jsonData={
          fileId:+this.fileId,
          status:CommonConstants.FILE_CUR
        }
        this.medicalFileService.updateFileStatus(jsonData).subscribe(res => {
          if (res['result'] && res['code'] === "0") {
            localStorage.setItem(CommonConstants.FILE_STATUS, CommonConstants.FILE_CUR);
            swal.fire(
              'Moved!',
              'Medical file moved to current patient status.',
              'success'
            )
          } else {
            swal.fire("Error", "Error Occured While updating file status", 'error');
          }
        },
        error => {
          swal.fire("Error", "Error Occured While updating file status", 'error');
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        
      }
    })
  }
  loadDataToCarePlaList(event){
    console.log(+JSON.stringify(event));
  }
}
